import { compose } from 'recompose'
import withType from 'components/common/hoc/withType'
import IndexableYMME from './IndexableYMME'
import { withGroupedList, withDynamicVerbiage, withImageSrc, mapStateToProps } from './hocs'
import { connect } from 'react-redux'


export default compose(
  withType({ type: [
    'VehicleMakerSelector',
    'VehicleModelSelector',
    'VehicleYearSelector',
    'VehicleSubmodelSelector',
    'VehicleTireBrandSelector'
  ]}),
  connect(mapStateToProps),
  withGroupedList,
  withDynamicVerbiage,
  withImageSrc
)(IndexableYMME)
